import {stage} from './stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        enabled: boolean;
        policyStoreId: string;
        region: string;
        namespace?: string;
    };
};

const config: ConfigShape = {
    prod: {
        enabled: true,
        policyStoreId: 'LUg8BiTrsEtRP8ptSTfjve',
        region: 'us-west-2',
        namespace: 'FlexiNetPortal'
    },
    test: {
        enabled: true,
        policyStoreId: 'N1NAh5BJ8gWNwrmcciZXcW',
        region: 'us-west-2',
        namespace: 'FlexiNetPortal'
    },
    dev: {
        enabled: true,
        policyStoreId: '6SRZhc9EMLA1pCeK4MUvH7',
        region: 'us-west-2',
        namespace: 'FlexiNetPortal'
    },
    ide: {
        enabled: true,
        policyStoreId: '6SRZhc9EMLA1pCeK4MUvH7',
        region: 'us-west-2',
        namespace: 'FlexiNetPortal'
    },
};

export default config[stage];
